import { decode } from 'html-entities';
import _ from 'lodash';

const Events = {
	
	name: 'Events',
	model: {

		idProperty: 'events__id',
		displayProperty: 'events__time',
		
		properties: [
			{ name: 'events__id',	mapping: 'id',	type: 'int', },
			{ name: 'events__song_id',	mapping: 'song_id',	type: 'int', },
			{ name: 'events__data',	mapping: 'data', },
			{ name: 'events__time',	mapping: 'time',	type: 'float', },
			{ name: 'events__event_type_id',	mapping: 'event_type_id',	type: 'int', },
		
			// { name: 'songs__id',	mapping: 'song.id',	type: 'int', },
			// { name: 'songs__file',	mapping: 'song.file', },
			// { name: 'songs__is_alt',	mapping: 'song.is_alt',	type: 'bool', defaultValue: false },
			// { name: 'songs__novox',	mapping: 'song.novox',	type: 'bool', defaultValue: false },
			// { name: 'songs__question_id',	mapping: 'song.question_id',	type: 'int', },
			// { name: 'songs__title',	mapping: 'song.title', },
		
			// { name: 'event_types__id',	mapping: 'event_type.id',	type: 'int', },
			// { name: 'event_types__name',	mapping: 'event_type.name', },
		],

		associations: {

			belongsTo: [
				'Songs',
				'EventTypes'
			],

		},

	},

	entity: {
		methods: {

			getSong: function() {
				const Songs = this.getAssociatedRepository('Songs');
				return Songs.getById(this.events__song_id);
			},

			getEventType: function() {
				const EventTypes = this.getAssociatedRepository('EventTypes');
				return EventTypes.getById(this.events__event_type_id);
			},
			
			getSiblings: function() {
				return this.getSong().getEvents();
			},

		},
	},

	repository: {
		type: 'lfr',
		local: {
			type: 'async',
			isPaginated: false,
			autoSave: true,
			methods: {
				decodeHtmlEntities: function () {
					const entities = this.entities;
					_.each(entities, (entity) => {
						entity.events__data = decode(entity.events__data);
					});
				},
			},
		},
		remote: {
			type: 'onebuild',
			isPaginated: false,
			autoSave: false,
		},
	},

};

export default Events;
